const urlconfig = {
  // If running outside Docker, set frontend_server to http://localhost:8080
  // This is generally used for server-side rendering or other server-related frontend logic.
  frontend_server: process.env.REACT_APP_FRONTEND_SERVER || 'http://oms-backend:8080',
  frontend: process.env.REACT_APP_FRONTEND || 'http://localhost:3000',

  // This variable defines the base URL for API calls from the frontend.
  // When running with Nginx proxy in Docker, it should be empty for relative paths.
  // When running frontend standalone, it might be 'http://localhost:8080' or a production API domain.
  backend_api_base_url: process.env.REACT_APP_BACKEND_API_BASE_URL || '',
};

module.exports = urlconfig;